import React, { Component } from "react";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { connect } from "react-redux";
import { InputGroup, Input, FormGroup } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import URL from "../../config/api";

import "./css/resource.css";

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

/**
 * Moves an item from one list to another list.
 */

const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};

const grid = 8;

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "white",
  padding: grid,
  width: "100%",
  display: "flex",
  justifyContent: "start",
  flexFlow: "wrap"
});
const getListStyleOrderOnly = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "white",
  padding: grid,
  width: "100%",
  display: "flex",
  flexDirection: "column"
});
const dropeListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "white",
  padding: grid,
  width: "100%",
  display: "flex",
  justifyContent: "start",
  border: "3px dashed #dedede",
  borderRadius: "7px",
  minHeight: "160px"
});
class DragAndDrop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      selected: []
    };
  }

  id2List = {
    droppable: "items",
    droppable2: "selected"
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    let items = this.props.list;

    items.forEach((elem, idx) => {
      items[idx].content = elem.name;
    });

    this.setState({
      items
    });
  }

  getList = id => this.state[this.id2List[id]];

  onDragEnd = result => {
    const { source, destination } = result;
    // dropped outside the list
    if (!destination) {
      return;
    }
    let draggedItem = result.draggableId;

    let target = result.destination.droppableId;

    if (source.droppableId === destination.droppableId) {
      // just order
      const items = reorder(
        this.getList(source.droppableId),
        source.index,
        destination.index
      );

      let toWhere = "list";
      if (source.droppableId === "droppable2") {
        this.setState({ selected: items });
        toWhere = "select";
      } else {
        this.setState({ items });
      }
      this.props.getOrder(items, toWhere);
    } else {
      // select
      let list = this.getList(source.droppableId);
      list.forEach(item => {
        if (item.id === draggedItem) {
          draggedItem = item;
        }
      });
      const result = move(
        this.getList(source.droppableId),
        this.getList(destination.droppableId),
        source,
        destination
      );
      if (this.props.dontChangeListOnSelect) {
        this.setState(
          {
            selected: result.droppable2
          },
          () => {
            if (target === "droppable2") {
              this.props.selectedItem(draggedItem);
            }
            this.props.getSelected(this.state.selected);
          }
        );
      } else {
        this.setState(
          {
            items: result.droppable,
            selected: result.droppable2
          },
          () => {
            if (target === "droppable2") {
              this.props.selectedItem(draggedItem);
            }
            this.props.getSelected(this.state.selected);
          }
        );
      }
    }
  };

  selectChange = item => {
    let { items } = this.state;
    items.forEach((selected, idx) => {
      if (item.id === selected.id) {
        if (selected.checked) {
          items[idx].checked = false;
        } else {
          items[idx].checked = true;
        }
      }
    });

    this.setState({
      items
    });

    this.props.getChecked(item);
  };

  render() {
    let time = new Date().getTime();

    return (
      <div>
        <DragDropContext
          onDragEnd={this.onDragEnd}
          className="warpTypeResources"
        >
          <Droppable droppableId="droppable" direction={this.props.direction}>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                style={
                  this.props.orderOnly
                    ? getListStyleOrderOnly(snapshot.isDraggingOver)
                    : getListStyle(snapshot.isDraggingOver)
                }
              >
                {this.state.items.map((item, index) => (
                  <Draggable key={item.id} draggableId={item.id} index={index}>
                    {(provided, snapshot) => (
                      <div
                        key={item.id}
                        className={
                          this.props.orderOnly ? "orderContent" : "typeBox"
                        }
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <div className="warp-item-dnd">
                          {this.props.checkbox ? (
                            <div>
                              <FormGroup className="filterCheckBox dndCheckBox">
                                <InputGroup>
                                  <Input
                                    placeholder="select"
                                    onChange={e => this.selectChange(item)}
                                    checked={item.checked}
                                    type="checkbox"
                                  />
                                </InputGroup>
                              </FormGroup>
                            </div>
                          ) : (
                            ""
                          )}
                          <div>
                            <div className="typeContent">
                              {!this.props.orderOnly ? (
                                item.image ? (
                                  <div className="typeImage">
                                    <img src={URL.img + item.image} alt="" />
                                  </div>
                                ) : (
                                  ""
                                )
                              ) : (
                                ""
                              )}
                              <div className="typeTitle">{item.content}</div>
                            </div>
                            <div className="typeFooter">
                              <i
                                className="fa fa-info-circle"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Tooltip na parte superior"
                              ></i>
                              {/* <i data-resource={item.id} className='fa fa-plus' onClick={this.addResource}></i> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
          {this.props.dropArea ? (
            <div>
              <div>{this.props.dropName}</div>
              <Droppable
                droppableId="droppable2"
                direction={this.props.direction}
              >
                {(provided, snapshot) => (
                  <div
                    key={`${time}droppable2`}
                    ref={provided.innerRef}
                    style={dropeListStyle(snapshot.isDraggingOver)}
                  >
                    {this.state.selected.map((item, index) => (
                      <Draggable
                        key={`${item.id}-selected-${
                          time * this.state.selected.length
                        }`}
                        draggableId={`${item.id}-selected-${time}`}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <div
                            key={`${item.id}-${time}`}
                            className="typeBox"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <div className="typeContent">
                              <div className="typeImage">
                                <img src={URL.img + item.image} alt="" />
                              </div>
                              <div className="typeTitle">{item.content}</div>
                            </div>
                            <div className="typeFooter">
                              <i className="fa fa-info-circle"></i>
                              {/* <i data-resource={item.id} className='fa fa-plus' onClick={this.addResource}></i> */}
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
          ) : (
            ""
          )}
        </DragDropContext>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DragAndDrop);
